var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2944 12.1192C64.7871 12.841 68.6211 19.2507 74.4877 21.9116C80.2923 24.5444 83.2033 26.0303 86.5313 31.1396C86.5313 31.1396 89.3173 36.1496 90.2764 42.3641C91.1288 47.8876 100.739 47.0345 98.7225 63.0624C98.7225 71.1755 88.3965 74.9553 85.7474 79.9066C82.1046 86.7149 85.3531 88.6044 80.003 94.3783C74.9976 99.7803 65.9924 101.362 58.2944 100.934C50.663 100.509 44.1618 95.9534 37.8139 92.0301C32.0152 88.4463 26.2578 84.5311 22.7545 78.9684C19.4146 73.6653 16.9753 67.2326 18.4291 61.2503C19.8743 55.3032 27.6464 52.5266 30.5149 47.0345C32.6034 43.0358 31.2367 38.2811 32.6424 34.037C34.4993 28.4304 35.4353 22.0761 40.1017 18.0891C44.8806 14.0058 51.8218 11.3997 58.2944 12.1192Z",
    fill: "#ECF1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9998 88.9524H78.8821C79.9867 88.9524 80.8821 88.0569 80.8821 86.9524V38.5182L65.3639 23H33.9998C32.8952 23 31.9998 23.8954 31.9998 25V86.9524C31.9998 88.0569 32.8952 88.9524 33.9998 88.9524Z",
    fill: "#AFC3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8625 48.1586C42.8625 47.8824 43.0864 47.6586 43.3625 47.6586H69.2435V50.7622H43.3625C43.0864 50.7622 42.8625 50.5384 42.8625 50.2622V48.1586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8625,
    y: 56.3663,
    width: 17.8669,
    height: 2.97782,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3641 38.5201L80.8823 38.5201L65.3641 23.0019L65.3641 36.5201C65.3641 37.6247 66.2595 38.5201 67.3641 38.5201Z",
    fill: "#99B1D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.dbb2af954687a740f5df86be0a7b652d.svg";
export { ForwardRef as ReactComponent };